import "./index.scss";

import * as React from "react";
import { createRoot } from "react-dom/client";

import {App} from "./components/app";
import {AppConfiguration} from "./core/config/app-configuration";
import {MapViewerConfiguration} from "./config/map-viewer-configuration";

import { JsonSerializer } from "typescript-json-serializer";

import esriRequest from "@arcgis/core/request";

import {AppState} from "./components/app/app-mobx";
import {Api} from "./components/app/api";
import RequestResponse = __esri.RequestResponse;

declare global {
    interface Window { mapAPI: Api | undefined }
}

const loadConfig = (url: string, file: string): Promise<RequestResponse> => {
    const path = url + "/" + file;
    return esriRequest(path, {
        responseType: "json"
    });
};

// TODO: auf APP_ROOT umstellen bzw. auf unterschiedliche URL pro Zielumgebung (Target)
// TODO: In JSON die Pfade auf Icons ersetzen je nach Target
const loadConfigs = async (url: string) =>
    // use typescript dynamic import to load the config json files
    await Promise.all([
        loadConfig(url, "core.json"),
        loadConfig(url, "mapviewer.json")
    ]);

// Map to the country class
try {
    // __CONFIG_ROOT__ is replaced by Webpack build process
    // see config/environments
    // noinspection UnnecessaryLocalVariableJS
    const configRoot = __CONFIG_ROOT__;
    loadConfigs(configRoot).then(([appJson, mapviewerJson]) => {
        const defaultSerializer = new JsonSerializer();
        const appConfig = defaultSerializer.deserializeObject<AppConfiguration>(appJson.data, AppConfiguration);

        // deserialize as specific configuration type, but pass it to the App as generic base class type
        const mapViewerConfig =
            defaultSerializer.deserializeObject(mapviewerJson.data, MapViewerConfiguration);
        if (appConfig && mapViewerConfig) {
            const appStore = new AppState();
            const container = document.getElementById("map-root");
            const root = createRoot(container!);
            root.render(
                <React.StrictMode>
                    <App
                        config={appConfig}
                        moduleConfig={mapViewerConfig}
                        appStore={appStore}
                        ref={(app) => {
                            window.mapAPI = app?.api;
                        }} // allows to access react app from outside react
                    />
                </React.StrictMode>
            );
        }
    }).catch((e) => {
        // eslint-disable-next-line no-console
        console.error(e);
    });
} catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
}
